import { Button, ListGroup } from "react-bootstrap";
import { BundleManifestComponent } from "../../models";

interface Props {
  component: BundleManifestComponent;
  isFirst: boolean;
  isLast: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onEdit: () => void;
  onRemove: () => void;
}

function componentLabel(component: BundleManifestComponent) {
  return component.type === "se" ? `se / ${component.package}` : component.type;
}

function componentVersion(component: BundleManifestComponent): string {
  if (component.artifacts.length === 1) return component.artifacts[0].version ?? "";
  if (component.type === "se") {
    return component.artifacts.find((artifact) => artifact.id === "logic")?.version ?? "";
  }
  return "Unknown";
}

export function ComponentListItem({
  component,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  onEdit,
  onRemove,
}: Props) {
  return (
    <ListGroup.Item className="d-flex align-items-center">
      <div className="flex-grow-1">
        <strong>{componentLabel(component)}</strong>
        {" — "}
        {component.name} @ <code>{componentVersion(component)}</code>
      </div>
      <Button
        size="sm"
        variant="outline-secondary"
        className="me-1"
        disabled={isFirst}
        onClick={onMoveUp}
        aria-label="Move component up"
      >
        ↑
      </Button>
      <Button
        size="sm"
        variant="outline-secondary"
        className="me-1"
        disabled={isLast}
        onClick={onMoveDown}
        aria-label="Move component down"
      >
        ↓
      </Button>
      <Button size="sm" variant="outline-primary" className="me-1" onClick={onEdit}>
        Edit
      </Button>
      <Button size="sm" variant="outline-danger" onClick={onRemove}>
        Remove
      </Button>
    </ListGroup.Item>
  );
}
